import { render } from "./ReturnSearch.vue?vue&type=template&id=405c9684"
import script from "./ReturnSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnSearch.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/returnSearch/ReturnSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "405c9684"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('405c9684', __exports__)) {
    console.log('reload')
    api.reload('405c9684', __exports__)
  }
  
  module.hot.accept("./ReturnSearch.vue?vue&type=template&id=405c9684", () => {
    console.log('re-render')
    api.rerender('405c9684', render)
  })

}


export default __exports__